import React, { useState } from "react";
import downArrow from "../../../assets/design-revamp-product/product-icons/product-arrow.svg";
import addIcon from "../../../assets/design-revamp-product/product-icons/add-icon.svg";
import "../../NewProduct/index.css";

export default function CertificatesAutocomplete({
  editProduct,
  certificateList,
  value,
  onChange,
}) {
  const [openDropdown, setOpenDropdown] = useState(false);
  const [localValue, setLocalValue] = useState(value);

  const handleToggleDropdown = () => {
    if (editProduct) {
      setOpenDropdown(!openDropdown);
    }
  };

  const handleRemoveCertificate = (indexToRemove) => {
    if (!editProduct) return;

    const newValue = localValue.filter((_, index) => index !== indexToRemove);
    setLocalValue(newValue);
    onChange(null, newValue);
  };

  const handleAddCertificate = (certificate) => {
    if (!editProduct) return;

    const newValue = [...localValue, certificate];
    setLocalValue(newValue);
    onChange(null, newValue);
  };

  return (
    <div className="variation-box">
      <div
        className="product-dropdown-top relative"
        onClick={handleToggleDropdown}
      >
        <div className="variation-header" style={{ color: "#664650" }}>
          <h3
            style={{
              fontSize: "14px",
              width: "85%",
              whiteSpace: "nowrap",
              marginRight: "10px",
            }}
          >
            Certificates
          </h3>
          <img
            src={downArrow}
            width={15}
            height={15}
            alt="Down Arrow Dropdown"
          />
        </div>
      </div>

      {openDropdown && (
        <div className="product-dropdown-body">
          {localValue.map((certificate, index) => (
            <div
              key={index}
              className="product-dropdown-items"
              style={{ color: "#664650" }}
            >
              <span>{certificate.cert_name}</span>
              <button
                onClick={() => handleRemoveCertificate(index)}
                className="remove-button"
                disabled={!editProduct}
              >
                ×
              </button>
            </div>
          ))}

          <div className="product-dropdown-add-item relative">
            <select
              onChange={(e) => {
                const selectedCertificate = certificateList.find(
                  (cert) => cert.cert_name === e.target.value
                );
                if (selectedCertificate) {
                  handleAddCertificate(selectedCertificate);
                }
              }}
              disabled={!editProduct}
              className="product-dropdown-add-item"
              style={{
                marginBottom: 0,
                width: "100%",
                border: "none",
                color: "#B4A7AF",
                fontSize: "12px",
              }}
            >
              <option value="" className="product-dropdown-add-item">
                Add certificate...
              </option>
              {certificateList
                .filter(
                  (cert) =>
                    !localValue.some(
                      (selected) => selected.cert_name === cert.cert_name
                    )
                )
                .map((certificate) => (
                  <option
                    key={certificate.cert_name}
                    value={certificate.cert_name}
                  >
                    {certificate.cert_name}
                  </option>
                ))}
            </select>
            <img
              src={addIcon}
              alt="Add Certificate Icon"
              width={18}
              height={18}
              style={{
                position: "absolute",
                right: "5px",
                top: "50%",
                transform: "translateY(-50%)",
                cursor: editProduct ? "pointer" : "default",
                opacity: editProduct ? 1 : 0.5,
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
}
